export function loginType(): 'I' | 'E' | null {
    return window.localStorage.getItem('LT') as 'I' | 'E' | null;
}

